export function findItemRecursive(tree, itemId, path = []) {
    for (const item of tree) {
        if (item.id === itemId) {
            // 找到目标项
            return [...path, item];
        }
        if (item.list && item.list.length > 0) {
            const result = findItemRecursive(item.list, itemId, [...path, item]);
            if (result) {
                // 子树中找到目标项
                return result;
            }
        }
    }
    // 未找到目标项
    return null;
}
